import { render, staticRenderFns } from "./primaryButton.vue?vue&type=template&id=5eb4a465"
import script from "./primaryButton.vue?vue&type=script&lang=js"
export * from "./primaryButton.vue?vue&type=script&lang=js"
import style0 from "./primaryButton.vue?vue&type=style&index=0&id=5eb4a465&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports